import React from "react";

// Chrome for a stats section — a Win98 group box. The eyebrow becomes the
// group-box legend, the title + view controls sit on a header row, and the
// chart itself renders in a sunken white well so content stays off the
// chrome grey. Children (chart logic/layout) are untouched.
export default function SectionCard({ eyebrow, title, note, actions, children }) {
  return (
    <fieldset className="win95-groupbox" style={{ marginBottom: 20, minWidth: 0 }}>
      <legend>{eyebrow || "Statistics"}</legend>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 12,
          flexWrap: "wrap",
          marginBottom: note ? 4 : 10,
        }}
      >
        <h3
          style={{
            margin: 0,
            minWidth: 0,
            fontFamily: "var(--font-chrome)",
            fontSize: "var(--tc-ui-lg)",
            fontWeight: 700,
            letterSpacing: 0,
            lineHeight: 1.3,
            color: "var(--chrome-outline)",
          }}
        >
          {title}
        </h3>
        {actions && <div style={{ display: "flex", gap: 4 }}>{actions}</div>}
      </div>
      {note && (
        <div
          style={{
            marginBottom: 10,
            fontFamily: "var(--font-chrome)",
            fontSize: 11,
            color: "var(--chrome-text-soft)",
          }}
        >
          {note}
        </div>
      )}
      <div
        style={{
          background: "var(--gnf-bg)",
          border: "2px solid",
          borderColor: "var(--bevel-sunken)",
          padding: "14px 16px",
        }}
      >
        {children}
      </div>
    </fieldset>
  );
}
